/**
 * @file_purpose  component created for sm-plexmedia-web page
 * @author Swarnali Ghosh
 * @Date_Created 27-02-2024
 * @Date_Modified 28-02-2024
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import WebBanner from '../webComp/WebBanner';
import WebGameSlider from '../webComp/WebGameSlider';
import WebProvider from './WebProvider';
import AuthModal from '../../components/auth/AuthModal';
import { useSelector, useDispatch } from 'react-redux';
import Games from '../../pages/game/Games';
import { resetListGame } from '../../redux/slices/GameSlice';

const WebContent = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const [state, setState] = useState({
        client_id: "",
        language: ""
    })
    const languageState = useSelector((state) => state.languageState);

    let languageCode = languageState.active_language.language_code;
    const [submitDisable, setSubmitDisable] = useState(false);
    const [showAuthModal, setShowAuthModal] = useState(false);

    const [isMainPage, setIsMainPage] = useState(true)

    const [categoryId, setCategoryId] = useState("");

    useEffect(() => {

        dispatch(resetListGame())

    }, [location?.pathname])

    const openAuthModal = () => {
        setShowAuthModal(!showAuthModal)
    }

    const handleModeChangeAuthModal = () => {
        setShowAuthModal(!showAuthModal)
    }

    const changeCategory = (categoryId) => {
        setCategoryId(categoryId)
    }


    return (
        <>
            <div className="container mid_sec">
                <div className="mid_ban">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <WebBanner />
                                {/* <div className="search_sec">
                                    <i className="fa-solid fa-magnifying-glass" />
                                    <input type="search" placeholder={languageCode == "en" ? "Search your game" : "게임 검색"} />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <WebGameCategory categoryId={categoryId} changeCategory={changeCategory} />
            {
                categoryId ? <Games category_id={categoryId} /> :
           
                <WebGameSlider />
            } */}
            <WebProvider />
            {/* <WebGameCategory categoryId={categoryId} changeCategory={changeCategory} /> */}
            {
                categoryId ? <Games category_id={categoryId} /> :
           
                <WebGameSlider />
            }
            <AuthModal showAuthModal={showAuthModal} handleModeChangeAuthModal={handleModeChangeAuthModal} />

        </>
    )
}

export default WebContent
